import React, { useState } from 'react'
import { FormSelectField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  ClientPlatformLimitDto,
  TradingViewCouponParametersDto,
} from 'api/Clients/Types/ClientDetailedDto'
import {
  TradingViewPlanDto,
  TradingViewPlanExpirationDaysDto,
} from 'api/Trading-Accounts/Types/TradingViewPlanDto'

interface Props {
  isOpen?: boolean
  onClose(): void
  modalData: ClientPlatformLimitDto
  tradingViewPlans: TradingViewPlanDto[]
  tradingViewPlanExpirationDays: TradingViewPlanExpirationDaysDto[]
  saveModalForm(data: ClientPlatformLimitDto): void
}

export const ClientDetailsDashboardAssignTradingViewPlan: React.FC<Props> = ({
  isOpen,
  onClose,
  modalData,
  tradingViewPlans,
  tradingViewPlanExpirationDays,
  saveModalForm,
}) => {
  const [couponParameters, setCouponParameters] = useState<TradingViewCouponParametersDto>({
    tradingViewPlanId: modalData.tradingViewCouponParameters?.tradingViewPlanId ?? 0,
    tradingViewPlanExpirationDaysId:
      modalData.tradingViewCouponParameters?.tradingViewPlanExpirationDaysId ?? null,
  })

  const isDurationVisible =
    couponParameters.tradingViewPlanId !== null && couponParameters.tradingViewPlanId !== 0

  const handlePlanChange = (value: string | number) => {
    const nextValue = Number(value)
    setCouponParameters((prev) => ({
      tradingViewPlanId: nextValue,
      tradingViewPlanExpirationDaysId:
        nextValue === 0 ? null : prev.tradingViewPlanExpirationDaysId,
    }))
  }

  const handleDurationChange = (value: string | number) => {
    setCouponParameters((prev) => ({
      ...prev,
      tradingViewPlanExpirationDaysId: Number(value),
    }))
  }

  const handleSave = () => {
    const tradingViewPlanId = couponParameters.tradingViewPlanId ?? null
    const tradingViewPlanExpirationDaysId =
      tradingViewPlanId === 0 ? null : (couponParameters.tradingViewPlanExpirationDaysId ?? null)

    saveModalForm({
      ...modalData,
      tradingViewCouponParameters: {
        tradingViewPlanId,
        tradingViewPlanExpirationDaysId,
      },
    })
  }

  const isSaveDisabled =
    couponParameters.tradingViewPlanId !== null &&
    couponParameters.tradingViewPlanId !== 0 &&
    couponParameters.tradingViewPlanExpirationDaysId === null

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Assign Trading View Plan</DialogTitle>
        </DialogHeader>
        <div className='flex flex-col gap-4'>
          <FormSelectField
            label='Plan Name'
            value={couponParameters.tradingViewPlanId ?? undefined}
            options={tradingViewPlans.map((plan) => ({
              id: plan.id,
              name: plan.name,
            }))}
            showSearch
            onChange={handlePlanChange}
          />
          <FormSelectField
            label='Default Expiration (Days)'
            value={couponParameters.tradingViewPlanExpirationDaysId ?? undefined}
            options={tradingViewPlanExpirationDays.map((duration) => ({
              id: duration.id,
              name: duration.name,
            }))}
            showSearch
            disabled={!isDurationVisible}
            onChange={handleDurationChange}
          />
        </div>
        <DialogFooter>
          <Button onClick={onClose} type='button' variant='outline'>
            Cancel
          </Button>
          <Button type='button' disabled={isSaveDisabled} onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
